import { isExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { JSM_CREATE_FORM_TEMPLATE_KEY } from '@atlassian/conversation-assistant-message-actions-api/constants';

export const isFormTemplateActionEnabled = (actionKey?: string): boolean =>
	actionKey === JSM_CREATE_FORM_TEMPLATE_KEY &&
	fg('soju-5536-forms-skill') &&
	isExperimentEnabled('rovo_chat_manage_forms_experiment');
